import PermissionsSet from "@/server/PermissionsSet";
let ctr = 1;

function registerTrigger(type, that, callback){
    if(!_.isString(type)){
        type = type.prototype?.__metadata__?.__type__;
    }
    if(!type){
        throw new Error("Type not recognized:" + JSON.stringify(type));
    }
    window['Log'].debug("$onTrigger::" + type);
    window['EventBus'].registerTrigger(type, that, callback);
}

export const EventBusPlugin = {
    install : function (Vue, options) {
        // 1. add global method or property
        // Vue.myGlobalMethod = function () {
        //     // some logic ...
        // }N

        // 2. add a global asset
        // Vue.directive('my-directive', {
        //     bind (el, binding, vnode, oldVnode) {
        //         // some logic ...
        //     }
        //     ...
        // })

        // 3. inject some component options
        Vue.mixin({
            beforeDestroy: function () {
                window['EventBus'].unregisterAllTriggers(this);
                for(let i in this._data){
                    if(this._data[i] && this._data[i] instanceof PermissionsSet){
                        this._data[i].detach();
                        window['Log'].debug("Detached permissionsSet")
                    }
                }
            }
        })

        // 4. add an instance method
        Vue.prototype.$onTrigger = function (type, callback) {
            registerTrigger(type, this, callback);
        }
        Vue.prototype.$onInsert = function (type, callback) {
            let that = this;
            window['Log'].debug("Registering $onInsert");
            registerTrigger(type, this, function(changeEvent){
                if(changeEvent.operation === "i"){
                    window['Log'].debug("$onInsert::" + type);
                    callback.apply(that, [changeEvent]);
                }
            });
        }
        Vue.prototype.$onUpdate = function (type, callback) {
            let that = this;
            registerTrigger(type, this, function(changeEvent){
                if(changeEvent.operation === "u"){
                    window['Log'].debug("$onUpdate::" + type);
                    callback.apply(that, [changeEvent]);
                }
            });
        }
        Vue.prototype.$onDelete = function (type, callback) {
            let that = this;
            registerTrigger(type, this, function(changeEvent){
                if(changeEvent.operation === "d"){
                    window['Log'].debug("$onDelete::" + type);
                    callback.apply(that, [changeEvent]);
                }
            });
        }
        Vue.prototype.$onChange = function (type, callback) {
            let that = this;
            registerTrigger(type, this, function(changeEvent){
                callback.apply(that, [changeEvent]);
            });
        }
        Vue.prototype.$onBulkChange = function (type, callback) {
            let that = this;
            registerTrigger(type, this, function(changeEvent){
                if(changeEvent.operation === "*"){
                    window['Log'].debug("$onBulk::" + type);
                    callback.apply(that, [changeEvent]);
                }
            });
        }
        Vue.prototype.$onEvent = function (type, callback) {
            if(!_.isString(type)){
                type = type.name;
            }
            window['EventBus'].registerEvent(type, this, callback);
        }
        Vue.prototype.$subscribe = async function (routingKey, callback) {
            await window['EventBus'].registerSubscription(routingKey, this, callback);
        }

        Vue.prototype.$tag = function(){
            if(this.__tag){
                return this.__tag;
            }
            this.__tag = ctr++;
            return this.__tag;
        }


    }
}